import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "discord",
  "name": "Discord",
  "category": "integrations",
  "description": "Send messages to Discord channels",
  "icon": "siDiscord",
  "iconType": "simple-icon",
  "color": "purple",
  "version": "2.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Discord",
    "color": "#5865f2"
  },
  "credentials": [
    {
      "name": "discordWebhook",
      "required": true,
      "displayName": "Discord Webhook"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "discord",
    "chat",
    "message",
    "gaming",
    "community"
  ],
  "comingSoon": true
};

export default definition;
